import { DatePipe } from "@angular/common";
import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output, Renderer2 } from "@angular/core";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { ActivatedRoute } from "@angular/router";
import { Ancora } from "src/app/shared/model/ancora.model";
import { ArvoreEstilos } from "src/app/shared/model/arvore-estilos.model";
import { CONSULTA_APP_SUITE, TipoConsulta } from "src/app/shared/model/tipo-consulta.model";
import { VisaoAto } from "src/app/shared/model/visao-ato.model";
import { VisaoSegmento } from "src/app/shared/model/visao-segmento.model";
import { Visao } from "src/app/shared/model/visao.model";
import { AtoService } from "src/app/shared/services/ato.service";
import { ConsultaAppRfbService } from "src/app/shared/services/consulta-app-rfb.service";
import { Base64 } from "src/app/shared/util/base64.util";
import { DataUtil } from "src/app/shared/util/data.util";

@Component({
    selector: 'app-exibir-visao',
    templateUrl: './exibir-visao.component.html',
    styleUrls: ['./exibir-visao.component.css']
})
export class ExibirVisaoComponent implements OnInit, AfterViewInit {

    @Input() visaoAto: VisaoAto;
    @Input() visaoSelecionada: Visao;
    @Input() urlFuncionalidade: string;
    @Input() exibirBotaoIrTopo = false;
    @Input() exibirDatasVigencia = false;
    @Input() tipoConsulta: TipoConsulta;
    @Input() tokenAppRfb: string;
    @Input() idSegmento: string;
    @Output() clickExcluirAnotacao = new EventEmitter<number>();
    @Output() clickAlterarDataInicioVigencia = new EventEmitter<Ancora>();
    @Output() clickAnotacao = new EventEmitter<{ancora :Ancora, ehPassiva: boolean}>();

    ancoraRepublicacao: Ancora;

    // implementação para [(epigrafeSelecionada)] two-way data binding
        private _epigrafeSelecionada: boolean;
        @Output()
            epigrafeSelecionadaChange = new EventEmitter<boolean>();
        @Input()
            set epigrafeSelecionada(epigrafeSelecionada: boolean) {
                this._epigrafeSelecionada = epigrafeSelecionada;
                this.epigrafeSelecionadaChange.emit(epigrafeSelecionada);
            }
            get epigrafeSelecionada(): boolean {
                return this._epigrafeSelecionada;
            }

    // implementação para [(segmentosSelecionados)] two-way data binding
        private _segmentosSelecionados: VisaoSegmento[];
        @Output()
            segmentosSelecionadosChange = new EventEmitter<VisaoSegmento[]>();
        @Input()
            set segmentosSelecionados(segmentosSelecionados: VisaoSegmento[]) {
                this._segmentosSelecionados = segmentosSelecionados;
                this.segmentosSelecionadosChange.emit(segmentosSelecionados);
            }
            get segmentosSelecionados(): VisaoSegmento[] {
                return this._segmentosSelecionados;
            }

    exibirEpigrafe: boolean;
    selecionavel: boolean;
    epigrafeSelecionavel: boolean;
    expandirHistorico = true;

    ancoraEditandoDataInicioVigencia: Ancora | null = null;
    dataInicioVigenciaVal: Date | null;

    exibirEspacamento = true;
    arvoreEstilos: ArvoreEstilos;
    // Permite alterar a data de vigência de todas as anotações do mesmo segmento.
    // Esta variável é utilizada para permitir uma rápida alteração em caso de algum problema
    // não identificado durante a implementação.
    permiteAlterarDataVigenciaTodasAnotacoes = true;

    constructor(
        private route: ActivatedRoute,
        private renderer: Renderer2,
        private atoService: AtoService,
        private consultaAppRfbService: ConsultaAppRfbService,
        private sanitizer: DomSanitizer
    ) {}

    ngOnInit(): void {
        this.exibirEpigrafe = this.visaoSelecionada.isAnotacao();
        this.selecionavel = this.visaoSelecionada.isAnotacao();
        this.epigrafeSelecionavel = this.visaoSelecionada.isAnotacaoDestino();
        this.epigrafeSelecionada = false;
        this.arvoreEstilos = new ArvoreEstilos(this.visaoAto.tiposSegmento);
        for (const s of this.visaoAto.ementas) {
            this.definirEstilo(s);
        }
        for (const s of this.visaoAto.outrosSegmentos) {
            this.definirEstilo(s);
        }
        if (!this.segmentosSelecionados) {
            this.segmentosSelecionados = [];
        }
    }

    ngAfterViewInit(): void {
        this.route.fragment.subscribe(fragmento => {
            let idSegmento = this.idSegmento;
            if (fragmento) {
                idSegmento = fragmento;
            }
            if (idSegmento) {
                setTimeout(() => {
                    this.rolarParaSegmento(idSegmento);
                }, 100);
            }
        });
    }

    definirEstilo(segmento: VisaoSegmento) {
        if (segmento.estiloSegmento) {
            const no = this.arvoreEstilos.incluirNoSegmento(segmento.idTipoSegmento, segmento.estiloSegmento);
            segmento.style = no?.getStyle(false);
        } else {
            segmento.style = this.arvoreEstilos.getStyle(segmento.idTipoSegmento, false);
        }
    }

    public rolarParaInicio() {
        window.scrollTo(0, 0);
    }

    private rolarParaSegmento(idSegmento: string) {
        const segmento = document.getElementById(idSegmento);
        if (segmento) {
            this.criarEspacoParaExibirSegmentoNoTopo(segmento);
            segmento.scrollIntoView({ behavior: 'smooth' });
        }
    }
    private criarEspacoParaExibirSegmentoNoTopo(segmento: HTMLElement) {
        // Espaço necessário é o tamanho da janela menos a distância do elemento até o final do documento
        let espacoNecessario = this.calcularEspacoNecessario(segmento);
        
        if(espacoNecessario > 0) {
            const espacamento = document.getElementById(`espacamento-${this.visaoAto.idAto}`);
            if (espacamento) {
                // Calcula o espaço ocupado até o final do documento
                const espaco = this.calcularEspacoOcupado(espacamento);
                // Calcula o tamanho da janela ocupado pelo componente de exibir visão
                const tamanhoJanela = this.calcularTamanhoDoJanela(segmento);
                // Se o espaço ocupado for menor que o tamanho da janela, aumenta o espaço necessário
                if(espaco < tamanhoJanela) {
                    espacoNecessario += tamanhoJanela - espaco;
                }
                // Atualiza a altura do elemento espaçamento
                this.renderer.setStyle(espacamento, 'height', `${espacoNecessario}px`);
            }
        } else {
            setTimeout(() => this.exibirEspacamento = false, 10);
        }
    }

    calcularTamanhoDoJanela(segmento: HTMLElement) {
        if (this.idSegmento) {
            // O tamanho da janele é o tamanho do elemento pai do segmento
            return segmento.parentElement?.parentElement?.offsetHeight ?? 0;
        } else {
            return window.innerHeight;
        }
    }

    calcularEspacoOcupado(espacamento: HTMLElement) {
        // O espaço ocupado pelo exibir visão é a distância do segmento até o inicio da janela
        let espaco = espacamento.getBoundingClientRect().bottom;
        if (!this.idSegmento) {
            espaco = espacamento.getBoundingClientRect().bottom;
            const footer = document.querySelector('footer');
            if (footer) {
                const footerMargenTop = parseFloat(getComputedStyle(footer).marginTop);
                espaco += footer.getBoundingClientRect().height + footerMargenTop;
            }
            const avisoSijut = document.querySelector('.aviso-sijut');
            if (avisoSijut) {
                espaco += avisoSijut.getBoundingClientRect().height;
            }
        }
        return espaco;
    }

    calcularEspacoNecessario(segmento: HTMLElement): number {
        const segRect = segmento.getBoundingClientRect();
        const tamanhoDaJanela = window.innerHeight;
        const tamanhoDoDocumento = document.documentElement.scrollHeight;

        let espacoNecessario = 0;
        if (this.idSegmento) {
            const parentElement = segmento.parentElement;
            if (parentElement) {
                const parentRect = parentElement.getBoundingClientRect();
                // Calcula a altura visível do elemento pai
                const alturaVisivel = parentElement.parentElement?.offsetHeight ?? parentElement.offsetHeight;
                // Calcula a altura do segmento até o topo do elemento pai
                const alturaTopSegmento = segRect.bottom - parentRect.top;
                // Calcula o espaço necessário para exibir o segmento no topo do elemento pai
                espacoNecessario = alturaVisivel - (parentRect.height - (alturaTopSegmento - segRect.height));
            }
        } else {
            // Calcula o espaço necessário para exibir o segmento no topo da janela
            espacoNecessario = tamanhoDaJanela - (tamanhoDoDocumento - (segRect.bottom - segRect.height));
        }
        return espacoNecessario;
    }

    getClass(segmento: VisaoSegmento): string {
        let classes = '';
        const segmentoSeleciondo = this.obterSegmentoSelecionado(segmento);
        if (segmentoSeleciondo) {
            classes = 'selecionado';
            if (segmentoSeleciondo.destaqueVermelho) {
                classes = 'selecionado destaque-vermelho'
            }
        }
        if (segmento.tachado) {
            classes = classes + ' tachado';
        }
        if (segmento.agendado) {
            classes = classes + ' agendado';
        }
        if (this.visaoSelecionada.isAnotacao()) {
            classes += ' segmento-selecionavel';
        }
        return classes;
    }

    getInnerHTML(segmento: VisaoSegmento): SafeHtml {
        if (segmento.omitir && this.visaoSelecionada.isAnotacao()) {
            return '--';
        }
        if (!segmento.innerHTMLSanitizado) {
            segmento.innerHTMLSanitizado = this.sanitizer.bypassSecurityTrustHtml(segmento.textoIntegra);
        }
        return segmento.innerHTMLSanitizado;
    }

    clickNoSegmento(segmento: VisaoSegmento) {
        segmento.destaqueVermelho = false;
        if (this.selecionavel) {
            if (this.visaoSelecionada.isAnotacaoDestino() && this.epigrafeSelecionada) {
                return;
            }
            const i = this.obterIndiceSegmentoSelecionado(segmento);
            if (i >= 0) {
                this.segmentosSelecionados.splice(i, 1);
            } else {
                this.segmentosSelecionados.push(segmento);
            }
        }
    }

    obterIndiceSegmentoSelecionado(segmento: VisaoSegmento): number {
        return this.segmentosSelecionados.findIndex(s => s.idSegmento == segmento.idSegmento && s.versaoSegmento == segmento.versaoSegmento);
    }
    
    obterSegmentoSelecionado(segmento: VisaoSegmento): VisaoSegmento | undefined {
        return this.segmentosSelecionados.find(s => s.idSegmento == segmento.idSegmento && s.versaoSegmento == segmento.versaoSegmento);
    }

    clickNaEpigrafe() {
        if (this.epigrafeSelecionavel && this.segmentosSelecionados.length == 0 ) {
            this.epigrafeSelecionada = !this.epigrafeSelecionada;
        }
    }

    clickDataInicioVigencia(anotacaoSegmento: Ancora) {
        if (this.visaoSelecionada.isAnotacao()) {
            if (this.ancoraEditandoDataInicioVigencia == anotacaoSegmento) {
                this.ancoraEditandoDataInicioVigencia = null;
            } else {
                const data = DataUtil.parseStrToDate(anotacaoSegmento.dataInicioVigencia);
                this.dataInicioVigenciaVal = data;
                this.ancoraEditandoDataInicioVigencia = anotacaoSegmento;
            }
        }
    }

    clickConfirmarDataInicioVigencia() {
        if (this.ancoraEditandoDataInicioVigencia) {
            const ancora = this.ancoraEditandoDataInicioVigencia;
            this.ancoraEditandoDataInicioVigencia = null;
            if (this.dataInicioVigenciaVal) {
                const datePipe = new DatePipe("en-US");
                const novaData = datePipe.transform(this.dataInicioVigenciaVal, 'dd/MM/yyyy');
                if (novaData) {
                    const novaAncora = new Ancora();
                    novaAncora.idAnotacao = ancora.idAnotacao;
                    novaAncora.dataInicioVigencia = novaData;
                    this.clickAlterarDataInicioVigencia.emit(novaAncora);
                }
            }
        }
    }

    clickCancelarDataInicioVigencia() {
        this.ancoraEditandoDataInicioVigencia = null;
    }

    verificarDataInicioVigenciaVal() {
        if (!this.ancoraEditandoDataInicioVigencia?.permiteAgendamento && this.dataInicioVigenciaVal) {
            if (this.dataInicioVigenciaVal > new Date()) {
                return false;
            }
        }
        return true;
    }

    verificarDataInicioVigenciaValAtoInconcluso() {
        if (!this.visaoAto.integro && this.dataInicioVigenciaVal && this.ancoraEditandoDataInicioVigencia) {
            const ancoras = [
                ...this.visaoAto.ancorasNoAto,
                ...this.visaoAto.ementas.map(s => s.ancorasDestino).flat(),
                ...this.visaoAto.outrosSegmentos.map(s => s.ancorasDestino).flat()
            ]; 
            const ancorasAgendadas = ancoras.filter(a => a.ehAgendamento); 
            if (ancorasAgendadas.length > 0) {
                ancorasAgendadas.sort((a1, a2) => {
                    const comparacao = DataUtil.compareDateStr(a1.dataInicioVigencia, a2.dataInicioVigencia);
                    if (comparacao != 0) {
                        return comparacao;
                    }
                    return a1.idAnotacao - a2.idAnotacao;
                });
                const vigencia = this.obterInicioEFimVigenciaValidaAnotacao(ancorasAgendadas);  
                
                if (!vigencia.inicioVigenciaValida) {
                    return this.dataInicioVigenciaVal <= (vigencia.fimVigenciaValida as Date);
                }
                if (!vigencia.fimVigenciaValida) {
                    return this.dataInicioVigenciaVal >= vigencia.inicioVigenciaValida;
                }
                if (vigencia.inicioVigenciaValida > vigencia.fimVigenciaValida) {
                    return this.dataInicioVigenciaVal >= vigencia.inicioVigenciaValida || this.dataInicioVigenciaVal <= vigencia.fimVigenciaValida;
                }           
                return this.dataInicioVigenciaVal >= vigencia.inicioVigenciaValida && this.dataInicioVigenciaVal <= vigencia.fimVigenciaValida;
            }
        }
        return true;
    }

    public obterInicioEFimVigenciaValidaAnotacao(ancorasAgendadas: Ancora[]) : {inicioVigenciaValida: Date | null, fimVigenciaValida: Date | null } {
        let inicioVigenciaValida: Date | null = null;
        let fimVigenciaValida: Date | null = null;
        for (let i = 0; i < ancorasAgendadas.length; i++) {
            if (this.ancoraEditandoDataInicioVigencia && ancorasAgendadas[i].idAnotacao == this.ancoraEditandoDataInicioVigencia.idAnotacao) {
                if (i > 0) {
                    inicioVigenciaValida = DataUtil.parseStrToDate(ancorasAgendadas[i-1].dataInicioVigencia);
                } 
                if (i < ancorasAgendadas.length - 1) {
                    fimVigenciaValida = DataUtil.parseStrToDate(ancorasAgendadas[i+1].dataInicioVigencia);
                }
            }   
        }
        if (!inicioVigenciaValida && !fimVigenciaValida) {
            inicioVigenciaValida = DataUtil.parseStrToDate(ancorasAgendadas[ancorasAgendadas.length-1].dataInicioVigencia);
            fimVigenciaValida =  new Date();
        }
        
        return {inicioVigenciaValida, fimVigenciaValida};
    }

    public baixarAnexo(segmento: VisaoSegmento) {
        if (!this.visaoSelecionada.isAnotacao() && segmento.arquivoBinario) {
            const idAnexo = segmento.arquivoBinario.idArquivoBinario;
            if (idAnexo) {
                this.atoService.downloadAnexoAto(segmento.arquivoBinario.nomeArquivoBinario, segmento.idAto, idAnexo, this.tipoConsulta);
            }
        }
    }

    public montarUrlAnexoNaConsultaApp(segmento: VisaoSegmento): string {
        if (!this.visaoSelecionada.isAnotacao() && segmento.arquivoBinario) {
            const idAnexo = segmento.arquivoBinario.idArquivoBinario;
            if (idAnexo) {
                return this.consultaAppRfbService.getUrlAnexoAto(segmento.idAto, idAnexo, this.tokenAppRfb);
            }
        }
        return "";
    }

    public decodeBase64(base64: string) {
        return Base64.decode(base64);
    }

    public getInnerHtmlAnexo(segmento: VisaoSegmento): SafeHtml {
        if (!segmento.anexoInnerHTMLSanitizado) {
            segmento.anexoInnerHTMLSanitizado = this.sanitizer.bypassSecurityTrustHtml(this.decodeBase64(segmento.arquivoBinario.arquivoBinario));
        }
        return segmento.anexoInnerHTMLSanitizado;
    }

    public getUrl(ancora: Ancora) {

        if (this.tipoConsulta == CONSULTA_APP_SUITE) {
            return this.getUrlParaConsultaAppSuite(ancora);
        }
        
        return this.urlFuncionalidade ? this.urlFuncionalidade + '/' + ancora.idAto : undefined;
    }

    private getUrlParaConsultaAppSuite(ancora: Ancora) {
        return this.urlFuncionalidade + '/' + ancora.idAto + '/' + this.tokenAppRfb;
    }

    public getFragmento(ancora: Ancora) {
        return ancora.idSegmento ? '' + ancora.idSegmento : undefined;
    }

    public getTitle(ancora: Ancora) {
        return this.visaoSelecionada.isAnotacao() ? 'Ato ID ' + ancora.idAto : '';
    }

    public isConsultaApp(): boolean {
        return this.urlFuncionalidade?.includes('/consulta/ato');
    }
}

export class ParametroAncora {
    idAto: string;
    visao: Visao;
    dia: number;
    mes: number;
    ano: number;
    abrirEmNovaGuia: boolean;
    abrirEmNovaJanela: boolean;
}
